<template>
    <button class="authorization-modal-button btn btn-social float-right" @click="$emit('click')">
        <font-awesome-layers class="fa-fw" style="font-size: 1.25rem">
            <font-awesome-icon :icon="['fad', 'address-card']" flip="horizontal" style="--fa-secondary-opacity: 1.0; --fa-primary-color: #402916; --fa-secondary-color: #402916"></font-awesome-icon>
            <font-awesome-icon :icon="['fad', 'address-card']" style="--fa-secondary-opacity: 1.0; --fa-primary-color: white; --fa-secondary-color: #402916"></font-awesome-icon>
            <font-awesome-icon :icon="['fas', 'crown']" transform="shrink-7 up-7 left-6 rotate--30" style="--fa-secondary-opacity: 0; color: #ffed00"></font-awesome-icon>
            <font-awesome-icon :icon="['fad', 'lock-alt']" transform="shrink-8 right-4.5" style="--fa-secondary-opacity: 1.0; --fa-primary-color: silver; --fa-secondary-color: #ffed00"></font-awesome-icon>
        </font-awesome-layers>
        <slot></slot>
    </button>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faAddressCard, faLockAlt} from '@fortawesome/pro-duotone-svg-icons';
    import {faCrown} from '@fortawesome/pro-solid-svg-icons';

    import {FontAwesomeIcon, FontAwesomeLayers} from "@fortawesome/vue-fontawesome";

    export default {
        name: 'AuthorizationModalButton',

        components: {
            'font-awesome-layers': FontAwesomeLayers,
            'font-awesome-icon': FontAwesomeIcon,
        },

        created() {
            library.add(faAddressCard, faCrown, faLockAlt);
        },
    }
</script>

<style lang="scss">
    .authorization-modal-button {
        :first-child {
            height: auto;
        }
    }
</style>
